import { ArrowUpRight, Flower2, MoonStar, Palmtree, Mic } from "lucide-react";
import { Reveal, ChapterHead } from "./Reveal";
import PhotoSlot from "./PhotoSlot";

// PHOTO CLIENT — dîner de la communauté
const IMG_POOL = "/images/diner-communaute.png";

const MISSIONS = [
  ["Ateliers", Flower2],
  ["Week-ends", MoonStar],
  ["Séjours & retraites", Palmtree],
  ["Prises de parole", Mic],
];

export default function Pros() {
  return (
    <section id="pros" data-testid="section-pros" className="relative py-28 md:py-36 overflow-hidden" style={{ background: "linear-gradient(180deg, rgba(214,71,142,0.17), rgba(255,179,71,0.15))" }}>
      <div className="orb w-[440px] h-[440px] bg-[#FF8E53] blur-[130px] opacity-30 top-1/3 left-[-12%]" aria-hidden="true" />

      <div className="wrap relative">
        <ChapterHead
          num="03"
          badge="Pour les pros & marques du bien-être · 100% clé en main"
          title="Intégrer un réseau, récolter des opportunités"
          note="En B2C comme en B2B : on vous propose des missions déjà qualifiées, on co-construit l'expérience. Vous n'avez rien à faire si ce n'est ce que vous savez faire de mieux : accompagner, guider, faire grandir."
        />

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <PhotoSlot
            src={IMG_POOL}
            index="04"
            caption="La communauté à table"
            ratio="aspect-[4/5]"
            speed={70}
            className="lg:sticky lg:top-28"
          />

          <div>
            <div className="border-t border-[#1C0E14]/10">
              {MISSIONS.map(([m, Icon], i) => (
                <Reveal key={m} delay={i * 0.06}>
                  <div
                    data-testid={`mission-row-${i + 1}`}
                    className="group flex items-center justify-between gap-6 py-7 border-b border-[#1C0E14]/10"
                  >
                    <div className="flex items-center gap-6">
                      <span className="flex items-center justify-center w-12 h-12 rounded-full bg-[#E8431F]/10 text-[#E8431F] shrink-0 transition-colors duration-300 group-hover:bg-[#E8431F] group-hover:text-[#FFF1E4]">
                        <Icon size={20} strokeWidth={1.6} />
                      </span>
                      <h3 className="font-display font-semibold text-2xl md:text-4xl transition-transform duration-500 group-hover:translate-x-2">
                        {m}
                      </h3>
                    </div>
                    <ArrowUpRight size={22} className="text-[#FF4B3E] opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal className="mt-10">
              <div data-testid="pros-bonus-card" className="glass rounded-[28px] p-8 md:p-10">
                <p className="eyebrow text-[#FF4B3E] mb-4">Le bonus</p>
                <p className="font-medium text-[#5F5258] leading-relaxed">
                  Vous pouvez aussi collaborer directement avec la marque Douceur Power, et
                  profiter de la visibilité d'une communauté Instagram déjà engagée sur les
                  sujets bien-être.
                </p>
              </div>
            </Reveal>

            <Reveal className="mt-10">
              <a
                href="mailto:alexia@ommymind.org?subject=Candidature%20r%C3%A9seau"
                data-testid="pros-cta"
                className="btn btn-ink"
              >
                Rejoindre le réseau
                <ArrowUpRight size={16} />
              </a>
            </Reveal>
          </div>
        </div>

        {/* 4 photos sous le CTA */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mt-14 md:mt-16">
          <PhotoSlot src="/images/evenement-communaute.png" index="p1" caption="Événements & communauté" ratio="aspect-[3/4]" speed={40} />
          <PhotoSlot src="/images/salon-terracotta.png" index="p2" caption="Lieux à vivre" ratio="aspect-[3/4]" speed={60} />
          <PhotoSlot src="/images/spa-peignoir.png" index="p3" caption="Spa & repos" ratio="aspect-[3/4]" speed={50} />
          <PhotoSlot src="/images/yoga-studio.png" index="p4" caption="Pratique en studio" ratio="aspect-[3/4]" speed={70} />
        </div>
      </div>
    </section>
  );
}
